import { Tooltip } from "antd";
import constant from "../constant";
const { brushs } = constant;
export default class BrushPanel extends React.Component {
  static defaultProps = {
    prefixCls: "wea-signature",
    brushs,
    color: "#000"
  };
  constructor(props) {
    super(props);
    this.state = {
      brush: props.brush || "md", // 默认中号字体
      toolTipVisible: false
    };
  }
  componentDidMount() {
    const { brush } = this.props;
    if (brush) this.setState({ brush });
  }
  compomentWillReceiveProps(nextProps) {
    const { brush } = nextProps;
    const { brush: _brush } = this.props;
    if (brush && brush !== _brush) {
      this.setState({ brush });
    }
  }
  onChangeBrush = brush => {
    this.setState({ brush });
    const { onChangeBrush } = this.props;
    if (typeof onChangeBrush === "function") onChangeBrush(brush);
  };
  getBrushContent = () => {
    const { brushs = [], prefixCls, color } = this.props;
    const { brush } = this.state;
    return brushs.map(b => {
      const style = brush === b ? { background: color } : {};
      return (
        <div
          className={`${prefixCls}-tools-dot ${brush === b &&
            `${prefixCls}-tools-dot-selected`}`}
          onClick={() => this.onChangeBrush(b)}
        >
          <div className={`${prefixCls}-tools-dot-${b}`} style={style} />
        </div>
      );
    });
  };
  onVisibleChange = visible => {
    this.setState({ toolTipVisible: visible });
  };
  render() {
    const { prefixCls, color } = this.props;
    const { brush, toolTipVisible } = this.state;
    return (
      <div className={`${prefixCls}-tools-dot ${prefixCls}-brushPanel`}>
        <Tooltip
          overlayClassName={`${prefixCls}-tools-dot-options`}
          placement="bottomLeft"
          arrowPointAtCenter
          autoAdjustOverflow
          title={this.getBrushContent()}
          visible={toolTipVisible}
          onVisibleChange={this.onVisibleChange}
        >
          <div className={`${prefixCls}-tools-dot-container`}>
            <div
              className={`${prefixCls}-tools-dot-${brush} ${prefixCls}-tools-dot-active`}
              style={{ background: color }}
            />
            <div className={`${prefixCls}-tools-dot-arrow`}>
              <i
                className={
                  !toolTipVisible
                    ? "icon-coms-Browse-box-Add-to"
                    : "icon-coms-Browse-box-delete"
                }
              />
            </div>
          </div>
        </Tooltip>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ecology9/wea-signature/signature-tools/BrushPanel.js